import React, { Component } from 'react';
import { connect } from "react-redux";
// import scss
import "./locationCostCenter.scss";
import Select from "react-select";
// redux
import Switch from '../../../../../../components/switch';
import { getCostCenterParents, getChildCostCenters, saveSOHSettings, GetLocationWage } from "../../../../../../store/actions";
import Loader from "../../../../../../components/loader";

class LocationCostCenter extends Component {
    constructor(props) {
        super(props)
    };

    state = {
        wageLocations: [],
        parentCostCenters: [],
        childCosetCenters: [],
        isFlatRate: false,
        selectedParent: {},
        selectedLocationBlank: {},
        selectedLocationFlat: {}
    };

    toggleFlatRate = (useless, val) => {
        this.setState({ isFlatRate: val })
    };

    async componentDidMount() {
        await this.props.GetLocationWage();
        await this.fetchCostCenterParents();
        await this.initView();
    };

    async componentDidUpdate(prevProps) {
        if (!this.props.SOH_SETTINGS) return;
        let { locationCCTreeIndex, locationBlank, useFlat, locationFlat, } = this.props.SOH_SETTINGS;
        let prevLCCTI = prevProps.SOH_SETTINGS?.locationCCTreeIndex;
        let prevLocBlank = prevProps.SOH_SETTINGS?.locationBlank;
        let prevUseFlat = prevProps.SOH_SETTINGS?.useFlat;
        let prevLocFlat = prevProps.SOH_SETTINGS?.locationFlat;
        if ((!isFinite(prevLCCTI) && Number(locationCCTreeIndex) >= 0)
            || (!prevLocBlank && locationBlank)
            || (!prevUseFlat && useFlat)
            || (!prevLocFlat && locationFlat)) {
            await this.initView();
        }
        else return;
    };

    initView = async () => {
        let selectedParent = {};
        let { SOH_SETTINGS } = this.props;
        SOH_SETTINGS = SOH_SETTINGS || {};
        let { locationCCTreeIndex, locationBlank, useFlat, locationFlat, } = SOH_SETTINGS;
        if (Number(locationCCTreeIndex) >= 0) {
            selectedParent = this.props.PARENT_COST_CENTERS.find(cc => cc.treeIndex === this.props.SOH_SETTINGS.locationCCTreeIndex);
            await this.onChangeSelectedParent(selectedParent);
        }
        if (locationFlat) {
            this.setState({ selectedLocationFlat: locationFlat });
        };
        if (locationBlank) {
            this.setState({ selectedLocationBlank: locationBlank });
        };
        this.setState({
            wageLocations: this.props.WageLocationReducer?.map(wl => ({ ...wl, value: wl._id, label: wl.name })) || [],
            selectedParent,
            isFlatRate: useFlat,
        });
    }

    fetchCostCenterParents = async () => {
        await this.props.getCostCenterParents(this.props.ClientDataReducer?._id);
        let costCenterData = this.props.PARENT_COST_CENTERS || []
        this.setState({
            parentCostCenters: costCenterData.map(cc => {
                return {
                    ...cc,
                    value: cc._id, label: `${cc.treeIndex + 1} ~ ${cc.name}`
                }
            })
        });
    };

    onChangeSelectedParent = async cc => {
        this.setState({ selectedParent: cc });
        await this.props.getChildCostCenters(this.props.ClientDataReducer?._id, cc.id);
        let childCosetCenters = this.props.CHILD_COST_CENTERS || [];
        let { mappedLocationCC } = this.props.SOH_SETTINGS;
        if (mappedLocationCC?.length) {
            childCosetCenters = childCosetCenters.map(ccc => {
                let mappedLocation = mappedLocationCC.find(mlc => mlc.costCenter?._id === ccc._id);
                if (mappedLocation) return { ...mappedLocation, ...ccc, };
                return ccc;
            });
        }
        this.setState({ childCosetCenters });
    };

    onSelectCCMapping = (i, val) => {

        let childCosetCenters = this.state.childCosetCenters;
        childCosetCenters[i].county = val;
        this.setState({ childCosetCenters });
    };

    saveCostCenterSettings = async () => {
        let { selectedParent, selectedLocationBlank, selectedLocationFlat, isFlatRate, childCosetCenters } = this.state;
        let mappedLocationCC = childCosetCenters.reduce((list, cc) => {
            if (cc.county) list.push({ costCenter: cc._id, county: cc.county._id });
            return list;
        }, []);
        let payload = {
            mappedLocationCC,
            locationBlank: selectedLocationBlank._id,
            locationFlat: selectedLocationFlat._id,
            useFlat: isFlatRate,
            locationCCTreeIndex: selectedParent.treeIndex
        };
        await this.props.saveSOHSettings(this.props.ClientDataReducer._id, payload);
    }

    render() {
        let { wageLocations,
            parentCostCenters,
            selectedParent,
            childCosetCenters,
            selectedLocationBlank,
            selectedLocationFlat,
            isFlatRate } = this.state;
        return (

            <div className="costCenter-list-height">
                <div className="d-flex align-items-center justify-content-end">
                    <span style={{ marginRight: '10px' }}>Flat Rate:</span>
                    <Switch
                        switchAction={this.toggleFlatRate}
                        id="flatRateNew"
                        value={isFlatRate}
                    ></Switch>
                </div>
                {isFlatRate ? (
                    <>
                        <div>
                            <span> Select the Location </span>
                            <Select
                                placeholder="Select Location"
                                options={wageLocations}
                                onChange={(val) => this.setState({ selectedLocationFlat: val })}
                                value={wageLocations.find(w => w._id === selectedLocationFlat._id)}
                                hideSelectedOptions={false}
                            />
                        </div>
                        <div className="d-flex align-items-center justify-content-end" style={{ marginRight: '15px', marginTop: '15px' }}>
                            <p className="fs14"><button className="btn reportBtn" onClick={this.saveCostCenterSettings} >Save</button></p>
                        </div>
                    </>) :
                    (<>
                        <div className="cost_center_select">
                            <div className="cost_center_outer d-flex align-items-center justify-content-between">
                                <div className="cost_flex_box">
                                    <span> Select the Cost Center</span>
                                    <Select
                                        placeholder="Cost Center"
                                        options={parentCostCenters}
                                        value={parentCostCenters.find(pc => pc._id === selectedParent._id)}
                                        onChange={this.onChangeSelectedParent}
                                        hideSelectedOptions={false}
                                    // styles={customStyles}
                                    />
                                </div>
                            </div>
                            <span className="pull-left" ></span>
                            <div className="reportListAccording mar-0">
                                <div className="reportId blank_location">
                                    <div className="row mt-3">
                                        <div className="col-md-6">
                                            <div className="listDiv">
                                                {/* <input type="text" id="blankValue" value={this.state.blankValue} onChange={(event) => this.setState({ blankValue: event.target.value })} /> */}
                                                <span>For Blank Fields</span>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="listDiv">
                                                {(
                                                    <Select
                                                        placeholder="Select Location"
                                                        options={wageLocations}
                                                        onChange={(val) => this.setState({ selectedLocationBlank: val })}
                                                        value={wageLocations.find(w => w._id === selectedLocationBlank._id)}
                                                        hideSelectedOptions={false}
                                                    />
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="table_list">
                            {this.state.loading ? (
                                <div className="ec_setup_contact df acc loading">
                                    <Loader></Loader>
                                </div>
                            ) : (
                                <div className="over_scroll">
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th scope="col">Cost Center</th>
                                                <th scope="col">External ID</th>
                                                <th scope="col">Abbreviation</th>
                                                <th scope="col">Location Center</th>
                                                <th scope="col" style={{ 'width': '130px' }}>Location ID</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {childCosetCenters.map((ccc, i) => (
                                                <tr key={ccc._id}>
                                                    <th scope="row">{ccc.treeIndex + 1}</th>
                                                    <td>{ccc.externalId}</td>
                                                    <td>{ccc.abbreviation}</td>
                                                    <td>{ccc.name}</td>
                                                    <td>
                                                        <Select
                                                            placeholder="Select Location"
                                                            options={wageLocations}
                                                            onChange={(val) => this.onSelectCCMapping(i, val)}
                                                            value={wageLocations.find(w => w._id === (ccc.county?._id || ccc.county))}
                                                            key={i}
                                                            hideSelectedOptions={false}
                                                        />
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                            <div className="d-flex align-items-center justify-content-end" style={{ marginRight: '15px', marginTop: '15px' }}>
                                <p className="fs14"><button className="btn reportBtn" onClick={this.saveCostCenterSettings} >Save</button></p>
                            </div>
                        </div>
                    </>
                    )}
            </div>
        )
    }
}
const mapStateToProps = ({ CostCenterReducer, ClientDataReducer, SOHSettingsReducer, WageLocationReducer }) => {
    const { PARENT_COST_CENTERS, CHILD_COST_CENTERS } = CostCenterReducer;
    const { SOH_SETTINGS } = SOHSettingsReducer;
    return { PARENT_COST_CENTERS, CHILD_COST_CENTERS, ClientDataReducer, SOH_SETTINGS, WageLocationReducer }
}

export default connect(mapStateToProps, {
    getCostCenterParents,
    getChildCostCenters,
    saveSOHSettings,
    GetLocationWage
})(LocationCostCenter);
